import mixpanel from "mixpanel-browser";

import { isAuthenticated } from "../../auth/auth";
import { axiosInstance } from "../../lib/axios";

import type { Response } from "mixpanel-browser";

async function checkIsAdBlockerInstalled(): Promise<boolean> {
  try {
    const response = await fetch(
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
      { method: "HEAD", mode: "no-cors", cache: "no-store" },
    );
    if (!response.ok) return true;
  } catch {
    return true;
  }
  return false;
}

export async function mixpanelCallback(
  response: Response,
  eventName: string,
): Promise<void> {
  if (
    (typeof response === "number" && response === 1) ||
    (typeof response === "object" && response.status === 1)
  ) {
    return;
  }

  const isUserAuthenticated = await isAuthenticated();

  if (
    !("sessionStorage" in window) ||
    !isUserAuthenticated ||
    sessionStorage.getItem("needl-analytics-reported")
  ) {
    return;
  }

  try {
    sessionStorage.setItem("needl-analytics-reported", "true");

    const data = {
      adblocker_installed: await checkIsAdBlockerInstalled(),
      mp_info: {
        event_name: eventName,
        has_user_opted_out_tracking: mixpanel.has_opted_out_tracking(),
        distinct_id: mixpanel.get_distinct_id(),
        email: mixpanel.get_property("$email"),
        name: mixpanel.get_property("$name"),
      },
      mp_error:
        typeof response === "object" && response.status === 0
          ? response.error
          : undefined,
    };

    await axiosInstance.post("/needl-analytics/report", data);
  } catch {
    sessionStorage.removeItem("needl-analytics-reported");
  }
}
